import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=2cc77111&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=2cc77111&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc77111",
  null
  
)

export default component.exports